import { IPreviewSamplePayload } from '@/types/request/illustrationTheme';

const STORAGE_KEY = 'illustrationTheme.previewSample';

// テスト生成のテンプレ変数差し込みに使う共通サンプル値の既定値（サーバーの SAMPLE_PREVIEW_PAYLOAD と同値）
export const DEFAULT_PREVIEW_SAMPLE: Required<IPreviewSamplePayload> = {
  diary:
    '今日は家族みんなで近所の公園に行きました。お弁当を食べて、とても楽しい一日でした。',
  numberOfFamilyMembers: 3,
  time: '2026-06-04',
  age: 70,
  gender: '女性',
  emotions: '楽しい',
};

export const loadPreviewSample = (): Required<IPreviewSamplePayload> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PREVIEW_SAMPLE;
    return { ...DEFAULT_PREVIEW_SAMPLE, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_PREVIEW_SAMPLE;
  }
};

export const savePreviewSample = (value: IPreviewSamplePayload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
};

export const resetPreviewSample = () => {
  localStorage.removeItem(STORAGE_KEY);
};
